import { css } from '@emotion/react';
import { useContext, useEffect } from 'react';
import Link from '../../../components/Link';
import veevaIdLogo from '../../../images/veeva-id-logo.svg';
import useMessageService from '../../../services/i18n/useMessageService';
import LocalizedMessage from '../../../components/LocalizedMessage';
import LoadingScreenContext from '../../../services/LoadingScreenContext';
import { AuthenticatedPaths } from '../../../constants/Paths';

const RegistrationSuccess = () => {
    const { setLoading } = useContext(LoadingScreenContext);
    const [
        [
            veevaIdLogoAlt = 'VeevaID logo',
            greeting = 'Thanks for registering your VeevaID account!',
            vaultDescription = 'Your VeevaID can now be used to log in to any Vault where you have an active membership.',
            linkDescription = 'You can access the {0} to edit your account information.',
            urlLabel = 'VeevaID Portal',
        ],
        loadingMessages,
    ] = useMessageService([
        'branded_logo.veeva_id_logo_alt',
        'registration.success_greeting',
        'registration.success_vault_description',
        'registration.success_link_description',
        'registration.success_url_label',
    ]);

    useEffect(() => {
        setLoading(loadingMessages);
    }, [loadingMessages, setLoading]);

    if (loadingMessages) {
        return null;
    }

    return (
        <div
            css={({ textColorLighter }) => css`
                display: flex;
                flex-direction: column;
                align-items: center;
                position: fixed;
                text-align: center;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                font-size: 1.667rem;
                max-width: 58.333rem;
                color: ${textColorLighter};
                width: 100%;
                padding: 20px;
                box-sizing: border-box;

                & > span + span {
                    margin-top: 20px;
                }
            `}
        >
            <img
                css={css`
                    height: 45px;
                    margin-bottom: 40px;
                `}
                src={veevaIdLogo}
                alt={veevaIdLogoAlt}
            />
            <span>
                <strong>{greeting}</strong>
            </span>
            <span>
                <strong>{vaultDescription}</strong>
            </span>
            <span>
                <strong>
                    <LocalizedMessage
                        template={linkDescription}
                        tokens={[
                            <Link
                                css={css`
                                    font-size: 1.667rem;
                                `}
                                key="VeevaIDPortalLink"
                                href={AuthenticatedPaths.HOME}
                            >
                                {urlLabel}
                            </Link>,
                        ]}
                    />
                </strong>
            </span>
        </div>
    );
};

export default RegistrationSuccess;
